import { computed, inject, Injectable, signal } from '@angular/core';
import { DroplistItem, PageTabsLayoutPageService } from '@eforall/dashboard';
import { EngagementExternalRoleId, EngagementGridContainerPage, EngagementType, StaffRoleId } from '@interfaces';
import { AdmissionsAreaService } from '../admissions-area.service';


/**
 * The list of tabs on this page
 */
export enum AdmissionsEngagementsPageTabId {
	Tab1 = 1,
	Tab2 = 2,
}

/**
 * The list if main tab droplist views on this page
 */
export enum AdmissionsEngagementsPageViewId {
	ContactReqs = 1,
	OpenEngagements = 2,
	CompletedEngagements = 3,
	FollowUps = 4,
}


@Injectable({ providedIn: 'root' })
export class AdmissionsEngagementsService extends PageTabsLayoutPageService<AdmissionsEngagementsPageTabId, AdmissionsEngagementsPageViewId> {

	public readonly areaService = inject(AdmissionsAreaService);
	public engagements = computed(() => this.areaService.admissionsData()?.engagements || []);
	public followUps = computed(() => this.areaService.admissionsData()?.followUps || []);
	public contactRequests = computed(() => this.areaService.admissionsData()?.contactRequests || []);
	public readonly page = signal<EngagementGridContainerPage>(EngagementGridContainerPage.Admission);
	public engagementType = signal<EngagementType | undefined>(undefined);
	public readonly staffRoleId = signal<StaffRoleId | undefined>(StaffRoleId.EnrollmentCoordinator);
	public externalRoleId = signal<EngagementExternalRoleId | undefined>(EngagementExternalRoleId.Entrepreneur);

	private static readonly _viewDroplistItems: DroplistItem<never, AdmissionsEngagementsPageViewId>[] = [
		{
			uniqueId: AdmissionsEngagementsPageViewId.ContactReqs, iconContext: {
				iconClass: 'fa-envelope-dot',
				iconStyle: 'fa-solid',
				text: 'Contact Requests',
				hideText: 'never',
			},
			customSort: '1-Views-1'
		},
		{
			uniqueId: AdmissionsEngagementsPageViewId.OpenEngagements, iconContext: {
				iconClass: 'fa-message-arrow-up-right',
				iconStyle: 'fa-solid',
				text: 'Open Engagements',
				hideText: 'never',
			}, customSort: '1-Views-2'
		},
		{
			uniqueId: AdmissionsEngagementsPageViewId.CompletedEngagements, iconContext: {
				iconClass: 'fa-message-check',
				iconStyle: 'fa-solid',
				text: 'Completed Engagements',
				hideText: 'never',
			},
			customSort: '1-Views-3'
		},
		{
			uniqueId: AdmissionsEngagementsPageViewId.FollowUps, iconContext: {
				iconClass: 'fa-reply-clock',
				iconStyle: 'fa-solid',
				text: 'Scheduled Follow Ups',
				hideText: 'never',
			},
			customSort: '1-Views-4'
		},
	];

	constructor() {
		super(AdmissionsEngagementsService._viewDroplistItems, AdmissionsEngagementsService.name, AdmissionsEngagementsPageTabId.Tab1, AdmissionsEngagementsPageViewId.OpenEngagements);
	}

	public get viewId() {
		return AdmissionsEngagementsPageViewId;
	}


	async reloadData() {
		await this.areaService.reloadData();
	}
}
